import React, { useEffect, useMemo, useRef, useState } from "react";
import allowlistIcon from "../../assets/icons/Allowlist-tab.png";
import frameCorner from "../../assets/icons/FrameFL.gif";
import welcomeIcon from "../../assets/icons/Welcome.png";
import founderGif from "../../assets/icons/Founder-Small.gif";
import secretHeirloomGif from "../../assets/icons/SecretHeirloom.gif";
import lockIcon from "../../assets/icons/Lock-tab.png";
import newTiersImg from "../../assets/icons/New-Tiers.png";
import referralsIcon from "../../assets/icons/referrals.svg";
import questsIcon from "../../assets/icons/quests.svg";
import "./StarterInfoModal.scss";

const LOCK_STARTER_TOURNEYS_TAB = true;

const TABS = [
  {
    id: "welcome",
    label: "Welcome",
    icon: welcomeIcon,
    content: (
      <>
        <p>
          Entering the kingdoms of Fortune Foes, an ambitious project built
          across 4 years, inspired by the nostalgic essence of the golden 2021
          NFT era, mixing deadly high-stakes mechanisms &amp; pixel perfection.
        </p>
        <p>
          This Dashboard is where you work towards Tiering Up your Allowlist for
          higher discounts &amp; Earn 10% Revenue Share through Referrals.
        </p>
        <p>
          &ldquo;The perfect allowlist system is where you&apos;re systematically
          rewarded based on: meaningful contributions, wallet history, rank in
          community tournaments &amp; a bit of luck.
        </p>
        <p>
          Not endless discord grinding, begging to get in a community
          manager&apos;s favor, or praying to get lucky in a raffle.&rdquo;
        </p>
        <div className="starter-info-founder-wrap">
          <span className="starter-info-founder-frame">
            <img
              src={founderGif}
              alt="Founder portrait"
              className="starter-info-founder-gif"
            />
          </span>
          <p className="starter-info-signoff">
            Pooria, Founder
            <br />
            (Fella NFT Degen who spent 250 ETH of Gas fees on Mints)
          </p>
        </div>
      </>
    ),
  },
  {
    id: "allowlist",
    label: "Allowlist",
    icon: allowlistIcon,
    content: (
      <>
        <p>
          <strong>Tiered Allowlist Program:</strong>
          <br />
          Users can earn points to climb through the Allowlist Tiers and unlock
          a Discount percentage for (both Bears & Bulls collection) sales.
          <br />
          Here are the 6 Tiers of the Allowlist, and the Discount % that they
          unlock:
        </p>
        <img
          src={newTiersImg}
          alt="Allowlist tiers and discount percentages"
          className="starter-info-allowlist-tiers"
          loading="lazy"
        />
        <p>
          Your Allowlist Tier &amp; Rank will be meaningfully considered for the
          Fortune Generation Event.
        </p>
        <p>
          You can stack Points through the different ways mentioned below:
        </p>
        <ul className="starter-info-list">
          <li>✦ Revenue Share Referral Program</li>
          <li>✦ [REDACTED] League ✦ [REDACTED] Bi-Weekly Tourney</li>
          <li>✦ 2022-2025 Early Development Witness Allowlist</li>
          <li>✦ Discord Events ✦ Discord Hall of Fame Roles</li>
          <li>✦ Contributions (Impact Based)</li>
          <li>✦ Collaborations ✦ Giveaways</li>
        </ul>
        <p>And more to be announced!</p>
        <p>
          <strong>IMPORTANT NOTE:</strong>
          <br />
          To have an Eligible profile in the system, you need to have completed
          all Authentication steps (Connect &amp; Follow X, Connect &amp; Join
          Discord). You will NOT be eligible for the Allowlist Perks before
          doing so.
        </p>
      </>
    ),
  },
  {
    id: "referral",
    label: "Referral",
    icon: referralsIcon,
    content: (
      <>
        <p>
          <strong>Referral System:</strong>
          <br />
          Share your Referral Link or Code to grow your network.
          <br /> You will get a 10% ETH Revenue Share from the users you have
          referred.
          <br /> Alongside that, you will receive Allowlist Points based on the
          number of users you refer.
          <br />
        </p>

        <ul className="starter-info-list">
          <li>✦ 2 Referrals → 2,000 Points</li>
          <li>✦ 5 Referrals → 5,000 Points</li>
          <li>✦ 10 Referrals → 8,000 Points</li>
          <li>✦ 25 Referrals → 14,000 Points</li>
          <li>✦ 50 Referrals → 25,000 Points</li>
          <li>✦ 75 Referrals → 35,000 Points</li>
          <li>✦ 100 Referrals → 50,000 Points</li>
        </ul>

        <p>
          The users who complete their authentication using your Referral Code /
          Link can also enjoy a Bonus of 1,000 Allowlist Points.
        </p>
        <p>
          <strong>Revenue Share Process: </strong>
          <br />
          The accumulated ETH from [10% of the] final successful bids
          (post-discount) of your Referrals will be sent to the wallet you
          signed up with, after completion of the Sales.
        </p>
        <div className="starter-info-founder-wrap starter-info-founder-wrap-heirloom">
          <span className="starter-info-founder-frame">
            <img
              src={secretHeirloomGif}
              alt="Heirloom NFT"
              className="starter-info-founder-gif"
            />
          </span>
          <p className="starter-info-signoff">
            Top 5 Referrers will be awarded the Heirloom NFT: The most scarce
            item in the universe of Fortune Foes.
          </p>
        </div>
      </>
    ),
  },
  {
    id: "tourneys",
    label: "Tourneys",
    icon: questsIcon,
    locked: LOCK_STARTER_TOURNEYS_TAB,
    content: (
      <>
        <p>
          Compete in active tourneys and climb leaderboards to earn additional
          allowlist points.
        </p>
        <p>
          Tournament rewards vary by rank bracket, so consistency can compound
          your edge.
        </p>
      </>
    ),
  },
];

const StarterInfoModal = ({ onClose, initialTab = "welcome" }) => {
  const getInitialActiveTab = () => {
    const matched = TABS.find((tab) => tab.id === initialTab);
    if (matched && !matched.locked) return matched.id;
    return "welcome";
  };
  const [activeTab, setActiveTab] = useState(getInitialActiveTab);
  const [isClosing, setIsClosing] = useState(false);
  const closeTimerRef = useRef(null);
  const activeTabData = useMemo(
    () => TABS.find((tab) => tab.id === activeTab) ?? TABS[0],
    [activeTab],
  );

  const requestClose = () => {
    if (isClosing) return;
    setIsClosing(true);
    closeTimerRef.current = setTimeout(() => {
      onClose();
    }, 220);
  };

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") requestClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
      clearTimeout(closeTimerRef.current);
    };
  }, [onClose]);

  useEffect(() => {
    const matched = TABS.find((tab) => tab.id === initialTab);
    if (matched && !matched.locked) {
      setActiveTab(matched.id);
    } else {
      setActiveTab("welcome");
    }
  }, [initialTab]);

  return (
    <div
      className={`starter-info-overlay${
        isClosing
          ? " starter-info-overlay--closing"
          : " starter-info-overlay--open"
      }`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="starter-info-title"
      onClick={requestClose}
    >
      <button
        type="button"
        className="starter-info-close-mobile"
        onClick={(e) => {
          e.stopPropagation();
          requestClose();
        }}
        aria-label="Close"
      >
        ×
      </button>
      <div
        className={`starter-info-modal${
          isClosing
            ? " starter-info-modal--closing"
            : " starter-info-modal--open"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="starter-info-topbar">
          <h2 id="starter-info-title" className="starter-info-title">
            LEAGUE INFO
          </h2>
          <div className="starter-info-tabs" role="tablist" aria-label="Tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                aria-disabled={tab.locked ? "true" : undefined}
                tabIndex={tab.locked ? -1 : undefined}
                className={`starter-info-tab${
                  tab.locked ? " starter-info-tab--disabled" : ""
                }${activeTab === tab.id ? " is-active" : ""}`}
                onClick={(e) => {
                  if (tab.locked) {
                    e.preventDefault();
                    return;
                  }
                  setActiveTab(tab.id);
                }}
              >
                {tab.locked ? (
                  <span
                    className="starter-info-tab-icon-slot"
                    aria-hidden="true"
                  >
                    <img
                      src={tab.icon}
                      alt=""
                      className="starter-info-tab-icon starter-info-tab-icon--slot-default"
                    />
                    <img
                      src={lockIcon}
                      alt=""
                      className="starter-info-tab-icon starter-info-tab-icon--slot-lock"
                    />
                  </span>
                ) : (
                  <img src={tab.icon} alt="" aria-hidden="true" />
                )}
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        <button
          type="button"
          className="starter-info-close"
          onClick={requestClose}
          aria-label="Close"
        >
          ×
        </button>
        <div className="starter-info-content" role="tabpanel">
          {activeTabData.content}
        </div>
        <img
          src={frameCorner}
          alt=""
          aria-hidden="true"
          className="starter-info-corner"
        />
      </div>
    </div>
  );
};

export default StarterInfoModal;
